import script from "./video-placeholder-tiktok.vue?vue&type=script&setup=true&lang=js"
export * from "./video-placeholder-tiktok.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__